import { useEffect, useState } from 'react';
import { useWallet } from '@/hooks/wallet';
import { getAccountAllV3 } from '@/services/account';
import { AccountPoolInfo } from '@/types/account';
import { useToast } from '@web3/base-hooks';
import { useFm } from '@web3/base-hooks';

export const useData = () => {
  const { walletAddresses } = useWallet();
  const [isLoading, setIsLoading] = useState(true);
  const { toastWarn } = useToast();
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState<AccountPoolInfo[]>([]);
  const pageSize = 5;

  const fetchData = async () => {
    setIsLoading(true);

    const { success, result, message } = await getAccountAllV3({
      walletAddresses,
    });

    setIsLoading(false);

    if (!success) {
      toastWarn(message);
      return;
    }

    setData(result);
    setTotal(result.length);
  };

  useEffect(() => {
    if (walletAddresses.length > 0) {
      fetchData();
    }
  }, [walletAddresses]);

  const onChangePageNo = (v: number) => {
    setPageNo(v);
  };

  return {
    data,
    isLoading,
    total,
    pageNo,
    pageSize,
    onChangePageNo,
  };
};

/**
 * 控制池子筛选
 */
export const useFilter = (data: AccountPoolInfo[]) => {
  const fm = useFm();
  const [currentPool, setCurrentPool] = useState('all');
  const filterData =
    currentPool === 'all'
      ? data
      : data.filter((item) => item.poolId === +currentPool);
  const filterList = [
    {
      value: 'all',
      label: fm('all_liquidity'),
    },
    ...data.map((item) => ({
      value: `${item.poolId}`,
      label: item.poolName,
    })),
  ];

  const onChangePool = (v: string) => {
    setCurrentPool(v);
  };

  return {
    filterData,
    currentPool,
    filterList,
    onChangePool,
  };
};
